module.exports = __webpack_public_path__ + "media/music/0e8ed599d9875c77d52db36de2b2b33f.mp3";